import { API } from "./brand";

export async function requestAIDemo({ industry, goal, sessionId, requestId, signal, onStatus, onDelta }) {
  const response = await fetch(`${API}/demo/plan`, { method: "POST", headers: { "Content-Type": "application/json", Accept: "text/event-stream" }, signal, body: JSON.stringify({ industry, goal, session_id: sessionId, request_id: requestId }) });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(typeof body.detail === "string" ? body.detail : "The AI could not start this plan. Please try again.");
  }
  if (!response.body || !response.headers.get("content-type")?.includes("text/event-stream")) throw new Error("The AI connection returned an unexpected response. Please retry.");
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  try {
    while (true) {
      const { value, done } = await reader.read();
      buffer += decoder.decode(value, { stream: !done });
      const frames = buffer.split("\n\n");
      buffer = frames.pop();
      for (const frame of frames) {
        const event = frame.split("\n").find(line => line.startsWith("event:"))?.slice(6).trim();
        const data = frame.split("\n").filter(line => line.startsWith("data:")).map(line => line.slice(5).trim()).join("\n");
        if (!data) continue;
        const payload = JSON.parse(data);
        if (event === "status") onStatus(payload);
        if (event === "token") onDelta(payload.delta);
        if (event === "error") throw new Error(payload.message);
        if (event === "complete") return payload;
      }
      if (done) throw new Error("The AI connection ended before a complete plan arrived. Please retry; no preset answer was substituted.");
    }
  } finally { await reader.cancel().catch(() => {}); }
}

export function partialDomainTitles(text) {
  const start = text.indexOf('"domains"');
  if (start < 0) return [];
  const end = text.indexOf('"routes"', start);
  const section = text.slice(start, end < 0 ? undefined : end);
  return [...section.matchAll(/"title"\s*:\s*("(?:[^"\\]|\\.)*")/g)].slice(0, 5).map(match => JSON.parse(match[1]));
}